import React from "react";
import Button from "@material-ui/core/Button";

const PopUpContact = (props) => {
  return (
    <div className="popup-box">
      <div style={{ background: "#fff", borderRadius: "1rem" }} className="box">
        <h2>Are You sure?</h2>
        <span>Do you really want to delete these records? This</span>
        <span>process cannot be undone</span>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={props.isOpenModal}
            style={{ background: "#005500" }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={props.isOnDelete}
            style={{ background: "red", marginLeft: "1rem" }}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PopUpContact;
